export interface ProfileFields {
  name?: string;
  beem_id?: string;
  telegram_username?: string;
  custom_photo_url?: string | null;
  photo_url?: string | null;
  eft_account_name?: string | null;
  eft_bsb?: string | null;
  eft_account_number?: string | null;
  default_buyin_method?: 'digital' | 'cash';
  default_payment_method?: 'beem' | 'eft' | null;
}

/**
 * Normalizes profile fields before saving:
 * - Trims whitespace from all string fields
 * - Ensures telegram_username starts with @ if non-empty
 * - Strips null/empty custom_photo_url and photo_url to null
 */
export function normalizeProfile(fields: ProfileFields): ProfileFields {
  const normalized: ProfileFields = {};

  if (fields.name !== undefined) {
    normalized.name = fields.name.trim();
  }
  if (fields.beem_id !== undefined) {
    normalized.beem_id = fields.beem_id.trim();
  }
  if (fields.telegram_username !== undefined) {
    let tg = fields.telegram_username.trim();
    if (tg.length > 0 && !tg.startsWith('@')) {
      tg = '@' + tg;
    }
    normalized.telegram_username = tg;
  }
  if (fields.custom_photo_url !== undefined) {
    normalized.custom_photo_url = fields.custom_photo_url || null;
  }
  if (fields.photo_url !== undefined) {
    normalized.photo_url = fields.photo_url || null;
  }
  if (fields.eft_account_name !== undefined) {
    const name = fields.eft_account_name?.trim();
    normalized.eft_account_name = name || null;
  }
  if (fields.eft_bsb !== undefined) {
    let bsb = fields.eft_bsb?.trim().replace(/\D/g, '') ?? '';
    if (bsb.length > 0) {
      if (bsb.length > 6) bsb = bsb.slice(0, 6);
      if (bsb.length >= 3) {
        bsb = bsb.slice(0, 3) + '-' + bsb.slice(3);
      }
    }
    normalized.eft_bsb = bsb || null;
  }
  if (fields.eft_account_number !== undefined) {
    let acct = fields.eft_account_number?.trim().replace(/\D/g, '') ?? '';
    if (acct.length > 9) acct = acct.slice(0, 9);
    normalized.eft_account_number = acct || null;
  }
  if (fields.default_buyin_method !== undefined) {
    normalized.default_buyin_method = fields.default_buyin_method;
  }
  if (fields.default_payment_method !== undefined) {
    normalized.default_payment_method = fields.default_payment_method;
  }

  return normalized;
}

export { createDefaultUserProfile } from './userDefaults';
